/* RECHARGE EVENT LISTENERS */
    let initRechargeWidget = false;
    window.addEventListener('ReChargeWidget-loaded', () => {
      var $widget_wrapper = $('.rc-custom-widget-wrapper');

      var productId = $widget_wrapper.data('productId');
      var variantId = $widget_wrapper.data('variantId');

      console.log('widget: ',productId, variantId, $widget_wrapper)
      
      //disable subscription if country is not united states because subscription is not available outisde US
      if(window.theme.country != "US") return false;

      //disablle if product id and variant id is not found
      if(!productId || !variantId) return false;

      console.log('continue');
      
      const config = {
        productId: productId, // Required
        injectionParent: 'form[action*="cart/add"]', // The node that will have the widget injected in
        injectionMethod: 'prepend', // How will the widget be injected 
        selectors: {
          price: ['[data-subscription-price]'], // the selectors that will be updated based on subscription !! IMPORTANT THIS IS JUST A DUMMY SELECTOR
        }
      };
  
      if(!initRechargeWidget){
        window.ReChargeWidget.createWidget(config);
        initRechargeWidget = true;
      }
  
      $('input[name="rc-custom-radio-group"]').change(function(){
        console.log($(this));
        let $wrapper = $(this).parents('.rc-custom-widget-container');
        let $subscribe_parent = $wrapper.find('.rc-custom-widget-subscribe-container');
        let $sellingPlanInput = $wrapper.find('#rc-custom-widget-selling-plan')
        if($(this).hasClass('rc-custom-widget-subscribe-input')){
          $subscribe_parent.addClass('active');
          $sellingPlanInput.prop('disabled', false);
        }else{
          $subscribe_parent.removeClass('active');
          $sellingPlanInput.prop('disabled', true);
        }
  
        $(document).trigger("atfchange");
      })
     
      
      window.ReChargeWidget.eventService.addEventListener('widget:build', async (widget) => {
        var activeVariant = variantId;
        var { variantSubscriptionData, sellingPlanGroups } = await fetchProductSubscriptionData(productId);
        buildRCDelivery(activeVariant, sellingPlanGroups, variantSubscriptionData);
        changeWidgetLabels(activeVariant, sellingPlanGroups, variantSubscriptionData);
        //show widget after recharge init;
        $('.rc-custom-widget-wrapper').show();
        $(document).trigger("atfchange");
  
        $(document).on('variantChange', function(variant){
          console.log('variantChange: ', variant);
          activeVariant = variant.variant.id;
          buildRCDelivery(activeVariant, sellingPlanGroups, variantSubscriptionData);
          changeWidgetLabels(activeVariant, sellingPlanGroups, variantSubscriptionData);
        })
      });
  
      window.ReChargeWidget.eventService.addEventListener('widget:sellingPlans:change', function(a,b,c){
        console.log('a', a);
      });
    });
  
    function changeWidgetLabels(activeVariant, sellingPlanGroups, variantSubscriptionData){
      let variant = variantSubscriptionData[activeVariant]
      let planGroupId = variant.selling_group_id;
      let planData = sellingPlanGroups[planGroupId];
      let $discount = $('[data-discount-text]');
      let $subSaveAmount = $('[data-price-subsave-amount]');
      let $subscriptionPrice = $('[data-subscribe-price]');
  
      let discountText = '';
      if(planData[0].price_adjustments_value_type == "percentage"){
        discountText = `${planData[0].price_adjustments_value}%`
      }
      $discount.text(discountText);
  
      let subSave = 0;
      subSave = parseFloat(variant.unit_price) - parseFloat(variant.discounted_price);
  
      //$subscriptionPrice.text(variant.discounted_price);
      $subscriptionPrice.html(slate.Currency.formatMoney(variant.discounted_price, theme.moneyFormat))
    
      if(!isNaN(subSave)) {
        $subSaveAmount.html(slate.Currency.formatMoney(subSave.toFixed(2), theme.moneyFormat))
        //$subSaveAmount.text('$' + subSave.toFixed(2));
      }
      
    }
  
    function buildRCDelivery(activeVariant, sellingPlanGroups, variantSubscriptionData){
      let planGroupId = variantSubscriptionData[activeVariant].selling_group_id;
      let planData = sellingPlanGroups[planGroupId];
      let $template = $(`
      <div class="custom-dropdown-container custom-close">
        <div class="custom-dropdown-active custom-dropdown" data-selling-id="${planData[0].selling_plan_id}" ><span class="dropdown-title-active custom-dropdown-title">Delivery:</span><span class="dropdown-text-active custom-dropdown-text">${planData[0].selling_plan_name}</span></div>
      </div>`);
  
      for(let i = 0; i < planData.length; i++){
        let $item = $(`<div class="custom-dropdown custom-dropdown-na" data-selling-id="${planData[i].selling_plan_id}" style="display: none;"><span class="custom-dropdown-title">Delivery:</span><span class="custom-dropdown-text">${planData[i].selling_plan_name}</span></div>`);
        $template.append($item);
      }
      //remove previous dropdown if any
      $('.rc-custom-widget-subscribe-container .js-delivery-dropdown .custom-dropdown-container').remove(); 
      $('.rc-custom-widget-subscribe-container .js-delivery-dropdown').append($template);
    }
  
    async function fetchProductSubscriptionData(productId){
  
     let variantSubscriptionData = {};
     let sellingPlanGroups = {}; 
     let productSubscriptionData = await window.ReChargeWidget.api.fetchProduct(productId);
      console.log('productSubscriptionData: ', productSubscriptionData);
      let groups = productSubscriptionData.selling_plan_groups;
      let variants = productSubscriptionData.variants;
      for(let i = 0; i < groups.length; i++){
        sellingPlanGroups[groups[i].selling_plan_group_id] = groups[i].selling_plans;
      }
  
      for(let i = 0; i < variants.length; i++){
        variantSubscriptionData[variants[i].id] = {
          selling_group_id: variants[i].selling_plan_allocations[0].selling_plan_group_id,
          unit_price: variants[i].prices.unit_price,
          discounted_price: variants[i].prices.discounted_price,
          compare_at_price: variants[i].prices.compare_at_price
        };
      }
  
      return {variantSubscriptionData, sellingPlanGroups};
    }